import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import ColumnH1 from '../atoms/columnH1'
import Introduction004 from './Introduction004'
import Introduction005 from './Introduction005'
import Introduction006 from './Introduction006'
import Introduction007 from './Introduction007'
import Introduction008 from './Introduction008'
import Introduction009 from './Introduction009'
import Introduction010 from './Introduction010'
import Introduction011 from './Introduction011'
import Introduction012 from './Introduction012'

const Wrapper = styled.article`
  position: relative;
  margin-bottom: 30px;

  .p-txt-date {
    margin-top: -10px;
    color: #ababab;
  }

  section {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 16px;
    color: #505050;
    line-height: 1.6em;

    h1 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #f5f5f5;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-bottom: 30px;
      margin-top: 10px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #77d7c9;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h2 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #ffffff;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-top: 10px;
      margin-bottom: 30px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #d8d8d8;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h3 {
      color: #414141;
      font-size: 16px;
      line-height: 1.4em;
      background: #ffffff;
      width: auto;
      padding: 10px 0 8px;
      margin-top: -10px;
      margin-bottom: 20px;
      border-top: solid 2px #e5e5e5;
      border-bottom: solid 2px #e5e5e5;
    }

    p {
      padding-bottom: 30px;
      line-height: 2;
      position: relative;

      span {
        background: linear-gradient(transparent 60%, #ff6 60%);
        font-weight: 600;
      }

      .p-list-link {
        position: absolute;
        top: 6px;
        right: 2px;

        &:before {
          display: block;
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          top: 7px;
          left: -14px;
          border-left: 8px solid #3ec7b3;
          border-top: 4px solid transparent;
          border-bottom: 4px solid transparent;
        }
      }

      &.txt-color-red {
        color: #ff6969;
      }
    }

    .link-div {
      width: 100%;
      display: flex;
      justify-content: left;
      padding-bottom: 30px;

      > div {
        width: 50px;
      }

      .link-p {
        width: calc(100% - 50px);

        .p-list-link {
          position: absolute;
          top: -3px;
          left: 30px;

          &:before {
            display: block;
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            top: 11px;
            left: -14px;
            border-left: 8px solid #3ec7b3;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
          }
        }
      }
    }

    img {
      width: 100%;
      height: auto;
      padding-bottom: 30px;
    }
  }

  ${BreakPoints.large} {
  }
`
type Props = {
  /** 広告の番号 */
  no: number
}

/**
 * コラム記事詳細：記事本体
 * @constructor
 */
const ColumnDetailInner0098 = (props: Props): JSX.Element => (
  <Wrapper>
    <ColumnH1 label="勤務時間の切り捨て（丸め）とは？そのメリットとデメリットを探る" />
    {/** TODO 川上申し送り事項：▼投稿日をここに表示 */}
    <p className="p-txt-date">2026.01.15</p>
    <section>
      {/** TODO 川上申し送り事項：▼記事投稿（？）で作成された内容がここに入る予定 */}
      <p>
        労務管理上多くの企業が直面する問題に勤務時間の切り捨て（いわゆる丸め）があります。近年は様々な勤怠ソフトが出されており、アナログよりもよりリアルな勤務時間の記録が可能です。何事も解釈の仕方を誤ると違法となることがあり、今回は、勤務時間の切り捨て（いわゆる丸め）について解説します。
      </p>
      <img src="/images/column/details/c0098.jpg" alt="キンクラコラム画像98" />
      <div id="toc1">
        <h1>勤務時間とは？</h1>
      </div>
      <p>
        勤務時間とは法律上の用語に置き換えると労働時間と解されます。まず、労働時間とは、使用者から指揮命令下に置かれた時間と解され、具体的にどのような場所でどのような業務を担ってもらう等の明示を受け、原則として雇用契約に基づいた時間内で労務提供が行われます。
        <span>すなわち、仕事をしている時間と言うこと</span>
        です。
      </p>

      <div id="toc2">
        <h1>端数処理</h1>
      </div>
      <p>
        労働基準法上、通達において
        <span>
          1か月における時間外労働、休日労働および深夜業の各々の時間数の合計において、29分以下を切り捨て、30分以上を1時間に切り上げとする処理は可能
        </span>
        と解されています。これは毎回必ず労働者が不利になるというわけではありませんので、
        <span>
          企業内で統一的なルールとして定め運用していく限りにおいて違法とはなりません
        </span>
        。
        <br />
        <br />
        ただし、違法事例として次のような運用は認められません。「日毎」において時間外労働、休日労働および深夜業の各々の時間数について29分以下を切り捨て、30分以上を1時間に切り上げとする処理です。
        <span>
          認められているのはあくまで「1か月」における時間外労働、休日労働および深夜業の各々の時間数のであり、「日毎」ではありません
        </span>
        。
      </p>

      <div id="toc3">
        <h1>メリット</h1>
      </div>
      <p>
        メリットとしては
        <span>給与計算事務担当者の負担軽減</span>
        です。当然、
        <span>時間外労働等の計算は分単位で支給しなければなりません</span>
        。他方、前述の1か月における時間外労働、休日労働および深夜業の各々の時間数の合計において、29分以下を切り捨て、30分以上を1時間に切り上げとする端数処理をすることで
        <span>事実上、分単位の計算から解放</span>
        されることから計算過程における負担が和らぐこととなり、かつ、計算ミスを防ぐことも可能となります。
      </p>

      <div id="toc4">
        <h1>デメリット</h1>
      </div>
      <p>
        デメリットとしては当然、前述の1か月における時間外労働、休日労働および深夜業の各々の時間数の合計において、29分以下を切り捨て、30分以上を1時間に切り上げとする端数処理はトラブル（特に29分以下を切り捨てた場合）防止の観点からも労働者へも周知すべきですが、
        <span>
          労働者が逆手に取り時間外労働時間数等の調整を行うようになること
        </span>
        です。例えば月の末日頃において、一例として1時間25分程度のところ、このままでは1時間未満の部分が切り捨てとなることから、本来必要のない労働を行い1時間25分のところ、1時間30分とすることなどが考えられます。当然、このような行為が蔓延すると事務負担は減るものの逆に人件費が上がってしまうという逆転現象が起こることもあります。
      </p>

      {/** ここに9パターンの広告設定する */}
      {props.no === 0 && <Introduction004 />}
      {props.no === 1 && <Introduction005 />}
      {props.no === 2 && <Introduction006 />}
      {props.no === 3 && <Introduction007 />}
      {props.no === 4 && <Introduction008 />}
      {props.no === 5 && <Introduction009 />}
      {props.no === 6 && <Introduction010 />}
      {props.no === 7 && <Introduction011 />}
      {props.no === 8 && <Introduction012 />}

      <div id="toc5">
        <h1>勤務時間の切り捨て</h1>
      </div>
      <p>
        本来、
        <span>
          労働時間は1分単位で認められるものであり、丸めは褒められる労務管理手法ではありません
        </span>
        。他方、労働時間とは前提として、
        <span>使用者からの指揮命令下に置かれた時間であり</span>
        、勤怠システム等への打刻をする際、物理的な導線上、一定のロスタイムが生じることもあり得ます。一般的に勤務終了後に直ちに打刻をするのが通常ですが、
        <span>並行して同僚との談笑を経て打刻することも十分に考えられます</span>
        。そうなると記録された全てが労働時間と解するには無理が生じます。そのような場合、
        <span>
          事業場内で統一的なルールとして、例えば時間外労働は事前承認制とし
        </span>
        、前述の勤怠システム等への打刻をする際、物理的な導線上生じた終業時刻後の打刻について、そのままにしてしまうと、給与システム上、丸めを行わなければ1分単位で画一的に時間外労働手当等を計算されてしまうプログラムが組まれている場合、
        <span>支給額が多くしまうため、丸めを行うという考え方です</span>
        。
        <br />
        <br />
        ただし、問題点としては
        <span>正確な時間ではなくなってしまうとの声があります</span>
        。よって、丸めを行っていない記録と別に出勤簿として丸めを行ったデータを保管しておくという労務管理手法です。必然的に後者の「出勤簿」が給与計算データと紐づく情報であり、計算結果と整合性のあるデータとなります。
      </p>

      <div id="toc6">
        <h1>労働時間は誰が管理すべきか？</h1>
      </div>
      <p>
        <span>労働時間は例外なく会社が管理しなければなりません</span>
        。例外的に認められる端数処理方法も確かにあるものの、その手法を正しく理解し、労働者の労働時間の把握を進める必要があります。労使トラブルの最上位は多くの企業で「賃金」です。正しい賃金計算は正しい労働時間の記録が土台としてなければならず、両輪として考えるべきです。また、丸めや労働時間の把握は、（実務上多くの場合で問題となるのは終業時刻が多いものの）終業時刻だけでなく、始業時刻についても、同様の考え方です。
      </p>

      <div id="toc7">
        <h1>最後に</h1>
      </div>
      <p>
        労働者数が増えてくると段階的に労働時間の管理はより煩雑化します。また、丸めについては直ちに法違反とはなりませんが、前提として、事業場内で統一的なルールとして周知をし、実際に運用していくことが極めて重要です。
      </p>
    </section>
  </Wrapper>
)

export default ColumnDetailInner0098
